import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CreditCardLock = function CreditCardLock(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20.25 17.5v-1.75c0-.9665-.7835-1.75-1.75-1.75s-1.75.7835-1.75 1.75v1.75M22 10H2m20 1V8.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 5 19.9201 5 18.8 5H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 6.5198 2 7.08 2 8.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 19 4.08 19 5.2 19H11m5.6 2.5h3.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 20.7401 22 20.4601 22 19.9v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437c-.2139-.109-.4939-.109-1.054-.109h-3.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C15 18.2599 15 18.5399 15 19.1v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109"
    })
  }));
};
export default CreditCardLock;